<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" class="text-center">
        <v-avatar size="140" class="shadow">
          <v-img :src="teacher.avatar"></v-img>
        </v-avatar>
      </v-col>
      <v-col cols="12" md="6">
        <app-editor v-model="teacher_profile.bio" ref="editor" />
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn @click="onSave" depressed color="#FF347C" outlined>Save</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";
import { patchTeacher } from "@/api/api";

export default {
  components: {
    appEditor: Editor,
  },
  data() {
    return {
      teacher_profile: {
        bio: {
          type: "doc",
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Write Bio here...",
                },
              ],
            },
          ],
        },
      },
    };
  },
  computed: {
    teacher() {
      return this.$store.getters["admin/teacher"];
    },
  },
  methods: {
    async onSave() {
      let teacher_profile = { ...this.teacher_profile };
      teacher_profile.bio = JSON.stringify(teacher_profile.bio);
      patchTeacher({
        uuid: this.teacher.uuid,
        body: { teacher_profile },
      });
    },
    create() {
      let teacher_profile = { ...this.teacher.teacher_profile };
      if (teacher_profile.bio) {
        teacher_profile.bio = JSON.parse(teacher_profile.bio);
        this.teacher_profile = teacher_profile;
        this.$refs.editor.editor.setContent(this.teacher_profile.bio);
      }
    },
  },
  watch: {
    "teacher.uuid"() {
      this.create();
    },
  },
  mounted() {
    this.create();
  },
};
</script>
